var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 180,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286 180",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "#holder_18cda6777cc text { fill:#999;font-weight:normal;font-family:Arial, Helvetica, Open Sans, sans-serif, monospace;font-size:14pt } "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "holder_18cda6777cc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 286,
    height: 180,
    fill: "#373940"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 107.19140625,
    y: 96.3
  }, "286x180")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolder);
export default __webpack_public_path__ + "static/media/holder.9f43516cd832c2bd6a8ed90e1177db79.svg";
export { ForwardRef as ReactComponent };